/*
 * Katana chrome — mobile menu.
 * On mobile the logo lockup (data-kmenu-toggle) opens/closes a full-screen
 * black overlay ([data-kmenu]); on desktop the lockup stays a normal home link.
 */
(function () {
  'use strict';

  function init() {
    var menu = document.querySelector('[data-kmenu]');
    var toggle = document.querySelector('[data-kmenu-toggle]');
    if (!menu || !toggle || toggle.dataset.kmenuBound) return;
    toggle.dataset.kmenuBound = '1';

    var mq = window.matchMedia('(max-width: 749px)');

    function isOpen() {
      return menu.classList.contains('is-open');
    }
    function open() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('kmenu-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('kmenu-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (e) {
      if (!mq.matches) return; // desktop: normal home link
      e.preventDefault();
      if (isOpen()) close();
      else open();
    });

    // Dedicated close (X) button that slides in left of the logos when open.
    var closeBtn = document.querySelector('[data-kmenu-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    }

    // Tap the black backdrop (outside the panel) to close.
    menu.addEventListener('click', function (e) {
      if (e.target === menu) close();
    });

    // Close after choosing a destination.
    Array.prototype.forEach.call(menu.querySelectorAll('a'), function (a) {
      a.addEventListener('click', close);
    });

    // Escape closes; leaving mobile width closes.
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && isOpen()) close();
    });
    var onChange = function () {
      if (!mq.matches) close();
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
